export default __webpack_public_path__ + "static/media/own-organisation-banner.af178550.jpg";